import { SalesOverviewReportTableAccessor } from '../../../../../../../enums/salesOverviewReportTableAccessor'

export const salesReportDateColumnsAccessors: string[] = [
  SalesOverviewReportTableAccessor.IssueDate,
  SalesOverviewReportTableAccessor.PaymentDate,
]
